
import Vue from 'vue'
import {Content} from '@chainsight/fad-backend-axios-sdk';

export default Vue.extend({
    name: 'ContentNode',
    components: {
    },
    data() {
        return {
        }
    },
    props: {
        contentNode: {
            type: Object as () => Content,
        }
    },
    computed: {
    },
    methods: {
        async mappingAssetUrl(){
            if(this.contentNode.nodeType === 'embedded-asset-block'){
                let imageData
                try{
                    imageData = await this.api$.contentfulApi.asset(this.contentNode.data?.target?.sys?.id as string)
                }catch (error) {
                    console.error(error)
                }
                this.contentNode.data!.uri = imageData.data.fields!.file.url;
            }
        },
        getContentList(contentNodeList: Content[]): Content[]{
            contentNodeList.shift()
            return contentNodeList
        }
    },
    created(){
        this.mappingAssetUrl()
    }
})
